export const changeElementStyle = (className: string, property: string, value: string) => {
  Array.from(
    document.getElementsByClassName(className) as HTMLCollectionOf<HTMLElement>,
  )[0].style.setProperty(property, value);
};
